const rankingItems = [
  { rank: 1, title: '修仙狂徒', type: '国漫·玄幻', hot: '980万', trend: 'up', desc: '少年踏上逆天修仙之路，热血与成长交织的史诗冒险。' },
  { rank: 2, title: '暗夜猎手', type: '韩漫·动作', hot: '860万', trend: 'up', desc: '黑夜中的猎人，用双刃守护城市，韩漫天花板级画风。' },
  { rank: 3, title: '甜蜜陷阱', type: '条漫·恋爱', hot: '750万', trend: 'up', desc: '总裁与灰姑娘的契约婚姻，甜到发齁的都市爱情。' },
  { rank: 4, title: '星海迷途', type: '日漫·科幻', hot: '620万', trend: 'new', desc: '浩瀚宇宙中的孤独航行者，寻找人类最后的希望。' },
  { rank: 5, title: '武道至尊', type: '国漫·武侠', hot: '580万', trend: 'up', desc: '以武证道，以拳破天，万人追捧的国漫武侠巅峰之作。' },
  { rank: 6, title: '恶魔的契约', type: '韩漫·奇幻', hot: '520万', trend: 'up', desc: '与恶魔签订契约的少年，游走于光明与黑暗之间。' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-trophy-line"></i>
            排行榜
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">人气榜单</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            本周最受读者欢迎的漫画作品，热门连载实时排名
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 md:gap-6 p-4 md:p-5 rounded-xl transition-all hover:bg-background-100 cursor-pointer ${
                i < rankingItems.length - 1 ? 'mb-2' : ''
              }`}
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl font-heading text-lg md:text-xl shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 truncate">{item.title}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.type}</span>
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-green-500 text-sm"></i>}
                  {item.trend === 'new' && <i className="ri-sparkling-line text-accent-500 text-sm"></i>}
                </div>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>
              <div className="text-right shrink-0">
                <div className="text-sm md:text-base font-heading text-primary-500">{item.hot}</div>
                <div className="text-xs text-foreground-400">人气</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}